import React from "react";
import "./index.css";

import imageResizer from "../../assests/imageResizer.png";
import collageMaker from "../../assests/collageMaker.png";
import dripEffect from "../../assests/dripEffect.png";
import sketchPhoto from "../../assests/sketchPhoto.png";
import textOnPhoto from "../../assests/textOnPhoto.png";
import backgroundOnBlur from "../../assests/backgroundOnBlur.png";
import wingAndSticker from "../../assests/wingAndSticker.png";
import removeBackground from "../../assests/removeBackground.gif";
import filter from "../../assests/filter.png";
import moveRight from "../../assests/moveRight.png"


function FewClick() {
  const data = [
    {
      title: "Image Resizer",
      buttonTitle: "Resize your Photo",
      imgSrc: imageResizer,
      description:
        "Transform the way you handle images with pixellab, where the power to quickly resize images is at your fingertips. No more waiting on designers or wrestling with complex software. Our image resizer puts you in control to achieve the perfect size in seconds, not hours",
    },
    {
      title: "Background Remover",
      buttonTitle: "Remove Background",
      imgSrc: removeBackground,
      description:
        "Instantly clean up your photos with our Background Remover tool. It’s a simple, fast way to cut out the clutter and focus on what matters in your images. Perfect for creating professional-looking portraits, product photos, or anytime you need a sleek, distraction-free background.",
    },
    {
      title: "Collage Maker",
      buttonTitle: "Customize your photo",
      imgSrc: collageMaker,
      description:
        "Make your photos stand out with pixellab’s Drip Effects. Add dynamic drip art and splashy designs for a modern, artistic look. Customize colors, shapes, and styles to turn everyday pictures into captivating masterpieces!",
    },
    {
      title: "Drip Effects",
      buttonTitle: "Apply Drip Effects",
      imgSrc: dripEffect,
      description:
        "Instantly clean up your photos with our Background Remover tool. It’s a simple, fast way to cut out the clutter and focus on what matters in your images. Perfect for creating professional-looking portraits, product photos, or anytime you need a sleek, distraction-free background.",
    },
    {
      title: "Photo Sketch",
      buttonTitle: "Photo to Sketch",
      imgSrc: sketchPhoto,
      description:
        "Experience the magic of art with pixellab’s Photo Sketch. Transform your images into hand-drawn masterpieces with a variety of sketch styles, from simple pencil lines to detailed shading. Artistic creativity is just a tap away!",
    },
    {
      title: "Text on Photo",
      buttonTitle: "Add text on photo",
      imgSrc: textOnPhoto,
      description:
        "Add personality and messages to your photos with pixellab’s Text on Photo. Choose from stylish fonts, custom colors, and effects to create captions, quotes, or memes that capture attention and tell your story.",
    },
    {
      title: "Background Blur",
      buttonTitle: "Blur photo BG",
      imgSrc: backgroundOnBlur,
      description:
        "Elevate your photography with pixellab’s Background Blur. Soften the background to highlight your subject, creating a professional depth-of-field effect that’s perfect for portraits and product photography.",
    },
    {
      title: "Wings & Stickers",
      buttonTitle: "Add Wings & Stickers",
      imgSrc: wingAndSticker,
      description:
        "Unleash your imagination with pixellab’s Wings & Stickers! Add magical wings, quirky stickers, and fun embellishments to bring your photos to life. Explore thousands of creative options for any style or mood.",
    },
    {
      title: "Photo Filters & Effects",
      buttonTitle: "Apply Filter & Effect",
      imgSrc: filter,
      description:
        "Enhance your pictures instantly with pixellab’s Photo Filters & Effects. From dramatic to dreamy, apply stunning filters and effects to create breathtaking visuals. Adjust tones, colors, and overlays to perfect your image.",
    },
  ];

  return (
    <div id="preview">
      <div className="fewClickimg_container">
        {data.map((d, index) => {
          return (
            <div className="featureImageContainer" key={index} >
              <img src={d.imgSrc} className="featureImage" alt={d.title} />
              <div className="textContent">
                <h1>{d.title}</h1>
                <span>{d.description}</span>
                <button className="featureImageButton" onClick={()=>{
                  window.open("https://onelink.to/f48f8n")
                }}>
                {d.buttonTitle}
                  <img src={moveRight}></img>
                 </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FewClick;
